module.exports = __webpack_public_path__ + "img/lg_ring_y_i_0_null@3x.ccdb6abd.png";